import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

class AboutUsSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            aboutUs: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/api/globals/about-us?depth=1`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                this.setState({
                    aboutUs: data,
                    loading: false,
                    error: null,
                });
            })
            .catch((error) => {
                console.error('About Us fetch error:', error);
                this.setState({
                    aboutUs: null,
                    loading: false,
                    error: error.message || 'Failed to load About Us content.',
                });
            });
    }

    getMediaUrl = (mediaObj) => {
        if (!mediaObj) return '';

        if (mediaObj.filename) {
            return `${process.env.REACT_APP_API_URL}/api/media/file/${mediaObj.filename}`;
        }

        if (mediaObj.url) {
            return mediaObj.url;
        }

        return '';
    };

    render() {
        const { aboutUs, loading, error } = this.state;

        if (loading) {
            return (
                <Container className="my-5">
                    <p className="text-center">Loading about us...</p>
                </Container>
            );
        }

        if (error) {
            return (
                <Container className="my-5">
                    <p className="text-center text-danger">Error: {error}</p>
                </Container>
            );
        }

        if (!aboutUs) {
            return (
                <Container className="my-5">
                    <p className="text-center">No About Us content found.</p>
                </Container>
            );
        }

        const {
            heroImage,
            heroTitle,
            heroDescription,
            storyTitle,
            storyDescription,
            processTitle,
            processDescription,
            featureCards,
            closingTitle,
            closingDescription,
        } = aboutUs;

        const cards = featureCards || [];
        const heroImageUrl = this.getMediaUrl(heroImage);

        const heroContainerStyle = {
            maxWidth: '100%',
            backgroundImage: heroImageUrl ? `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${heroImageUrl})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            paddingTop: '6rem',
            paddingBottom: '1rem',
            marginBottom: '2rem',
            textShadow: '0 3px 3px rgba(0,0,0,0.9)'
        };

        return (
            <span>
                <Container style={heroContainerStyle}>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={9} md={10} xs={12}>
                            {heroTitle && (
                                <h1 style={{ color: '#fff' }}>
                                    {heroTitle}
                                </h1>
                            )}
                            {heroDescription && (
                                <p
                                    style={{
                                        marginTop: '1rem',
                                        color: '#fff',
                                        lineHeight: '1.7',
                                        fontSize: '1.05rem',
                                    }}
                                >
                                    {heroDescription}
                                </p>
                            )}
                        </Col>
                    </Row>
                </Container>

                <Container>
                    <Row className="justify-content-center mb-5">
                        <Col lg={10} xs={12}>
                            <div>
                                {storyTitle && <h2 className="mb-3">{storyTitle}</h2>}
                                {storyDescription && (
                                    <p
                                        style={{
                                            margin: 0,
                                            color: '#666',
                                            lineHeight: '1.7',
                                        }}
                                    >
                                        {storyDescription}
                                    </p>
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mb-5">
                        <Col lg={10} xs={12}>
                            <div>
                                {processTitle && <h2 className="mb-3">{processTitle}</h2>}
                                {processDescription && (
                                    <p
                                        style={{
                                            margin: 0,
                                            color: '#666',
                                            lineHeight: '1.7',
                                        }}
                                    >
                                        {processDescription}
                                    </p>
                                )}
                            </div>
                        </Col>
                    </Row>

                    {cards.length > 0 && (
                        <Row className="mb-5">
                            {cards.map((card, index) => (
                                <Col key={index} lg={3} md={6} xs={12} className="mb-4">
                                    <div>
                                        {card.title && <h4 className="mb-3">{card.title}</h4>}
                                        {card.description && (
                                            <p
                                                style={{
                                                    margin: 0,
                                                    color: '#666',
                                                    lineHeight: '1.6',
                                                }}
                                            >
                                                {card.description}
                                            </p>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    )}
                </Container>

                <Container className="text-white pt-4 pb-4" style={{ maxWidth: '100%', background: "rgb(60, 60, 60)" }}>
                    <Row className="justify-content-center text-center">
                        <Col lg={9} md={10} xs={12}>
                            {closingTitle && <h2 className='text-primary'>{closingTitle}</h2>}
                            {closingDescription && (
                                <p
                                    style={{
                                        marginTop: '1rem',
                                        lineHeight: '1.7',
                                        fontSize: '1.05rem',
                                    }}
                                >
                                    {closingDescription}
                                </p>
                            )}
                        </Col>
                    </Row>
                </Container>
                {console.log('aboutUs:', aboutUs)}
                {console.log('heroImage:', heroImage)}
            </span>
        );
    }
}

export default AboutUsSection;